import { createGlobalStyle } from "styled-components";

export const tyPopoverCls = "ty-popover";

export const PopoverInjectStyle = createGlobalStyle`body, html {
  ${`.${tyPopoverCls}`} {
    &.ant-popover .ant-popover-inner {
      border-radius: 12px;
      background-color: var(--Fill_Background_Light);
      color: var(--Text_Primary);
      font-size: 15px;
      font-weight: normal;
      line-height: 24px;
      padding: 12px 16px 16px;
      border: 1px solid var(--Line_Secondary);

      .ant-popover-title {
        font-weight: 500;
        margin-bottom: 3px;
      }
    }
  }}
`;
